import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { UpdateExpertLevelRequest } from "@shopexperts/legacy-api";

interface UpdateAdminExpertLevelInput {
  expertLevelId: number;
  body: UpdateExpertLevelRequest;
}

export function useUpdateAdminExpertLevel() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["admin", "expert-levels", "update"],
    mutationFn: async ({ expertLevelId, body }: UpdateAdminExpertLevelInput) => {
      return await api.admin.expertLevels.updateLevel({
        params: { expertLevel: expertLevelId },
        body,
      });
    },
    onSuccess: (_level, variables) => {
      toaster.create({ title: "Expert level updated successfully", type: "success" });
      queryClient.invalidateQueries({ queryKey: ["admin", "expert-levels"] });
      queryClient.invalidateQueries({ queryKey: ["admin", "expert-levels", variables.expertLevelId] });
    },
    onError: (error: Error) => {
      toaster.create({ title: `Failed to update expert level: ${error.message}`, type: "error" });
    },
  });
}
